/***
 * Model that represents an activities weather information.
 */
import Backbone from 'backbone';

var UserDevice = Backbone.Model.extend({
    urlRoot: '/device-service/deviceservice/user-device/',

    backend: 'gcapi',

    idAttribute: 'deviceId',

    isVivoki: function() {
        return this.get('applicationKey') == 'vivoki';
    }
});

export default UserDevice;
